import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import s from './MLSelect.module.css';

class MLSelect extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })),
    defaultOptionIndex: PropTypes.number,
    placeHolder: PropTypes.string,
    labelledBy: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    testId: PropTypes.string,
    onClick: PropTypes.func,
    batchAssignLP: PropTypes.bool,
    fullWidth: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOpt: _.get(props, `options[${props.defaultOptionIndex}].value`, ''),
    };
  }

  onChangeInternal = (evt) => {
    const newValue = evt.target.value;
    const { onChange } = this.props;
    this.setState((prevState) => {
      if (onChange) {
        // call on change with value and prev value
        onChange(newValue, prevState.selectedOpt);
      }
      return { selectedOpt: newValue };
    });
  }

  render() {
    const { selectedOpt } = this.state;
    const {
      className,
      disabled,
      labelledBy,
      options,
      placeHolder,
      defaultOptionIndex,
      testId,
      onClick,
      batchAssignLP,
      fullWidth,
    } = this.props;

    const intentionallyNotSelected = options[defaultOptionIndex] &&
      (options[defaultOptionIndex].label === 'Multiple Selected'
        || options[defaultOptionIndex].value === 'placeholder');

    const onClickInternal = () => {
      if (onClick) onClick();
    };

    let selectValue = _.get(this.props, `options[${this.props.defaultOptionIndex}].value`, '');
    if (!batchAssignLP && (intentionallyNotSelected || defaultOptionIndex === undefined)) selectValue = selectedOpt;

    return (
      <select
        disabled={disabled}
        aria-labelledby={labelledBy}
        className={`${s.mlSelect} ${className} ${disabled ? s.mlSelectDisabled : ''} ${fullWidth ? s.mlSelectFullWidth : ''}`}
        onClick={onClickInternal}
        onChange={this.onChangeInternal}
        value={selectValue}
        data-test-id={testId}
      >
        {selectedOpt === '' &&
          !intentionallyNotSelected &&
          !batchAssignLP &&
          <option
            disabled
            value={''}
          >
            {placeHolder}
          </option>
        }
        {_.map(options, (opt, i) => (
          <option
            disabled={opt.disabled}
            key={i}
            value={opt.value}
          >
            {opt.label}
          </option>
        ))}
      </select>
    );
  }
}

export default MLSelect;
